/**
 * A series of helpers to automatically initiate downloads to the user's system
 */
export const download = {
    /**
     * Starts a download via a URL
     *
     * @param url A URL
     * @param name The default name of the file to be downloaded
     */
    url: (url: string, name?: string): void => {
        const link = document.createElement('a');

        link.style.visibility = 'hidden';
        link.style.position = 'fixed';
        link.setAttribute('href', url);
        if (name) {
            link.setAttribute('download', name);
        }

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    /**
     * Starts a download of a blob
     *
     * @param blob A blob object
     * @param name The default name of the file to be downloaded
     */
    blob: (blob: Blob, name?: string): void => {
        // Creates a special in-browser URL of the blob object
        const url = URL.createObjectURL(blob);

        // Downloads like a URL
        download.url(url, name);

        // Clean up the memory of the blob object url
        // So the browser doesn't have to store the memory for the whole blob as well
        URL.revokeObjectURL(url);
    },

    /**
     * Get a CSV Blob from csv string
     * @param csvString
     * @returns CSV Blob
     */
    getCSVBlob: (csvString: string): Blob => {
        if (!csvString) {
            return new Blob([], { type: 'text/csv;charset=utf-8;'});
        }
        // '\ufeff' makes it not break UTF-8 characters
        return new Blob(['\ufeff', csvString], { type: 'text/csv;charset=utf-8;'});
    }
};
